import {
    DefenseAssign,
    MovePlayer,
    PassBall,
    SetPick,
    Shoot,
    AddComment,
    WaveMove,
    DrawRectangle,
    DrawEllipse,
    ZoneMove,
    PassBallAlt,
} from '@labradorsports/assets';

import PlayConfig from './play-config.js';

const { ToolTypes } = PlayConfig;

const Tools = {
    Move: {
        name: 'Move',
        type: ToolTypes.MOVE,
        icon: <MovePlayer />,
    },
    Move2: {
        name: 'Move 2',
        type: ToolTypes.MOVE2,
        icon: <WaveMove />,
    },
    Zone: {
        name: 'Zone',
        type: ToolTypes.ZONE,
        icon: <ZoneMove />,
    },
    Pick: {
        name: 'Pick',
        type: ToolTypes.PICK,
        icon: <SetPick />,
    },
    Pass: {
        name: 'Pass',
        icon: <PassBall />,
        type: ToolTypes.PASS,
    },
    Shoot: {
        name: 'Shoot',
        type: ToolTypes.SHOOT,
        icon: <Shoot />,
    },
    Option: {
        name: 'Option',
        type: ToolTypes.OPTION,
        icon: <DefenseAssign />,
    },
    Groundball: {
        name: 'Ground Ball',
        type: ToolTypes.GROUNDBALL,
        icon: <PassBallAlt />,
    },
    Assign: {
        name: 'Assign',
        type: ToolTypes.ASSIGN,
        icon: <DefenseAssign />,
    },
    Comment: {
        name: 'Comment',
        icon: <AddComment />,
        type: ToolTypes.COMMENT,
    },
    Rectangle: {
        name: 'Rectangle',
        icon: <DrawRectangle />,
        type: ToolTypes.RECTANGLE,
    },
    Ellipse: {
        name: 'Ellipse',
        icon: <DrawEllipse />,
        type: ToolTypes.ELLIPSE,
    },
};

const playerMovement: any[] = [Tools.Move, Tools.Pick, Tools.Move2, Tools.Zone, Tools.Assign];

const ballMovement: any[] = [Tools.Pass, Tools.Shoot, Tools.Option, Tools.Groundball];

const fieldMarkup: any[] = [Tools.Comment, Tools.Rectangle, Tools.Ellipse];

const moveShapes = [
    {
        type: ToolTypes.MOVE,
        icon: <MovePlayer />,
    },
    {
        type: ToolTypes.PICK,
        icon: <SetPick />,
    },
    {
        type: ToolTypes.MOVE2,
        icon: <WaveMove />,
    },
    {
        type: ToolTypes.ZONE,
        icon: <ZoneMove />,
    },
];

export default {
    playerMovement,
    ballMovement,
    fieldMarkup,
    moveShapes,
};
